/*
* Won jobs (entered into quickbooks / quickbooks invoice sent report) for authenticated users
*/

import '@progress/kendo-ui';
import * as React from 'react';
import * as _ from 'lodash';
import moment from 'moment';
import { Grid } from '@progress/kendo-grid-react-wrapper';
import { Row, Button, Well, ButtonToolbar, DropdownButton, MenuItem, Modal } from 'react-bootstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { connectRequest } from 'redux-query';
import { withRouter } from 'react-router-dom';

import * as Actions from '../actions';
import * as AppComp from '../common/app-component-base';
import * as ReduxQueries from '../queries';
import ApiEndpoints from '../config/apiendpoints';
import * as MutateActions from '../actions/mutate';
import AppConfiguration from '../config/configuration';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import { GridUtilities } from '../common/grid/gridutilities';
import { NavigationLinks } from '../common/navigation';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';
import { ButtonGroup } from 'rsuite';

export const JobBulkUpdateOperations = {
    SetJobsInvoiceSent: 'set-jobs-invoice-sent',
    SetJobsEnteredIntoQuickbooks: 'set-jobs-entered-into-quickbooks',
};

export const JobBulkUpdateFields = {
    JobInvoiceSent: 'invoiceSent',
    JobEnteredIntoQuickbooks: 'enteredIntoQuickbooks',
};

export interface IWonJobsProps extends AppComp.IAppComponentProps {
    search?: any;
    updateWonJobs?: any;
    forceRequest?: any;
    dispatch?: any;
    navigateTo?: any;
}

export interface IWonJobsState extends AppComp.IAppComponentState {
    selectedKeys?: any;
    formChanges?: any;
    bulkUpdateJobsOperation: string;
    bulkUpdateJobsValue: any;
    showModalBulkUpdateJobs: boolean;
}

class WonJobs extends AppComp.AppComponent<IWonJobsProps, IWonJobsState> {
    public MomentDateFormat: string = AppConfiguration.getMomentShortDateFormat();
    public kendoGridWidgetRef: any;

    public gridOptions = GridUtilities.kendoGridOptionsPaging(
        // public gridOptions = GridUtilities.kendoGridOptions(
        [
            GridUtilities.kendoGridColumnDefinition('', '', 30, 100, undefined, { selectable: true }),
            GridUtilities.kendoGridColumnDefinition('associationId', this.appTextGridColumnHeader('association-id'), 70, 1),
            GridUtilities.kendoGridColumnDefinition('associationName', this.appTextGridColumnHeader('association-name'), 180, 2),
            GridUtilities.kendoGridColumnDefinition('orderStatus', this.appTextGridColumnHeader('order-status'), 100, 3),
            GridUtilities.kendoGridColumnDefinition('wonDateFormatted', this.appTextGridColumnHeader('won-date'), 90, 4),
            GridUtilities.kendoGridColumnDefinition('clientName', this.appTextGridColumnHeader('client-name'), 180, 5),
            GridUtilities.kendoGridColumnDefinition('contactEmail', this.appTextGridColumnHeader('contact-email'), 180, 5),
            GridUtilities.kendoGridColumnDefinition('contactName', this.appTextGridColumnHeader('contact-name'), 130, 5),
            GridUtilities.kendoGridColumnDefinition('clientCity', this.appTextGridColumnHeader('client-city'), 130, 6),
            GridUtilities.kendoGridColumnDefinition('regionName', this.appTextGridColumnHeader('region-name'), 130, 7),
            GridUtilities.kendoGridColumnDefinition('serviceLevelName', this.appTextGridColumnHeader('service-level'), 180, 8),
            GridUtilities.kendoGridColumnDefinition('acceptedPrice', this.appTextGridColumnHeader('accepted-price'), 90, 9, undefined,
                                                    {
                                                        aggregates: ['sum'],
                                                        footerTemplate: '#= kendo.toString(sum, "C") #',
                                                        format: '{0:c}',
                                                    }),
            GridUtilities.kendoGridColumnDefinition('viewOrderDetailLink', '', 80, 10,
                                                    GridUtilities.kendoGridLinkColumnTemplate('viewOrderDetailLink', 'viewOrderDetailLinkHref', this.appText('view-order-detail-link-title')),
                                                    { headerTemplate: '' }),
        ],
        this.appText('no-results'),
        {
            persistSelection: true,
            widgetRef: (w) => { this.kendoGridWidgetRef = w; },
            change: (e) => {
                const selectedKeys = e.sender.selectedKeyNames();
                this.handleGridRowCheckbox(selectedKeys);
            },
        },
        // this.appTextPageTitle()
    );

    public constructor(props: IWonJobsProps) {
        super(props, 'app.won-jobs.');

        this.state = {
            selectedKeys: [],
            showModalBulkUpdateJobs: false,
            bulkUpdateJobsOperation: '',
            bulkUpdateJobsValue: '',
            formChanges: {},
        };
    }

    public componentDidMount() {
        const enforce = this.enforceAdminOrEmployeeOnly();

        if (enforce) { this.props.navigateTo(NavigationLinks.clientDashboardHome()); }
    }

    public extendGridData(records: Array<any>) {
        // Extend grid row data
        if (!records) { return []; }

        return records.map( r => {
            let record = _.cloneDeep(r);
            const associationEmail = _.get(record, 'association.contact.email');
            const email = associationEmail ? associationEmail : _.get(record, 'contact.email', '');
            const associationContactName = _.get(record, 'association.contact');
            let contactName = '';
            if (associationContactName) {
                contactName = associationContactName.salutation + ' '
                             + associationContactName.firstName + ' '
                             + associationContactName.lastName;
            }
            // console.log(record);

            record.associationName = _.get(record, 'association.name', '').trim();
            record.orderStatus = _.get(record, 'status.name', '');
            record.clientName = _.get(record, 'client.name', '').trim();
            record.contactEmail = email;
            record.contactName = contactName;
            record.clientCity = _.get(record, 'client.location.city', '').trim();
            record.regionName = _.get(record, 'client.region.name', '').trim();
            record.serviceLevelName = _.get(record, 'serviceLevel.name', '').trim();

            record.wonDateFormatted = '';
            if (record.wonDate) { record.wonDateFormatted = moment(record.wonDate).format(this.MomentDateFormat); }

            // View order detail link
            record.viewOrderDetailLink = '';
            record.viewOrderDetailLinkHref = '';
            if (record.orderId) {
                record.viewOrderDetailLink = this.appText('view-order-detail-link-title');
                // record.viewOrderDetailLinkHref = NavigationLinks.orderEdit(record.orderId);
                record.viewOrderDetailLinkHref = NavigationLinks.orderDetail(record.orderId);
            }

            return record;
        });
    }

    // Handlers
    public handleGridRowCheckbox(keys: any) {
        const nextSelectedKeys = _.cloneDeep(keys);
        const prevSelectedKeys = _.get(this.state, 'selectedKeys', []);
        const same = _.isEqual(nextSelectedKeys, prevSelectedKeys);

        if (!same) { this.setState({ selectedKeys: nextSelectedKeys }); }
    }

    public handleShowModalBulkUpdateJobs(e: any, o: string = '', v?: any) {
        this.setState({ showModalBulkUpdateJobs: true, bulkUpdateJobsOperation: o, bulkUpdateJobsValue: v });
    }

    public handleCloseModalBulkUpdateJobs(resetState: boolean = false) {
        if (resetState) {
            this.setState({ showModalBulkUpdateJobs: false, bulkUpdateJobsOperation: '', bulkUpdateJobsValue: undefined, formChanges: {} });
        } else {
            this.setState({ showModalBulkUpdateJobs: false, bulkUpdateJobsOperation: '', bulkUpdateJobsValue: undefined });
        }
    }

    public handleConfirmBulkUpdateJobsButton(e: any, updateField: string, updateValue: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const jobOrders = _.map(_.get(this.state, 'selectedKeys', []), (o) => {
            let result = _.merge(
                {},
                {
                    _id: o,
                    // 20201321 was: bulkUpdate: true,
                });

            _.set(result, updateField, updateValue);

            return result;
        });

        const changeData = _.merge(
            {},
            { orders: jobOrders },
        );

        // console.log(`won-jobs/index::handleConfirmBulkUpdateJobsButton`, { changeData });
        // return null;

        this.props.updateWonJobs(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                if (this.kendoGridWidgetRef) { this.kendoGridWidgetRef.clearSelection(); }
                this.handleCloseModalBulkUpdateJobs(true);
                this.props.forceRequest();
            } else {
              // Error during creation...
            }
        });
    }

    public handleSelectReportMode(e: any) {
        const value = e;
        this.props.dispatch(Actions.searchWonJobsFilterMode(value));
    }

    // Renderers
    public renderBulkUpdateJobsModal = () => {
        const bulkOperation = Formatters.getStr(this.state, 'bulkUpdateJobsOperation');
        if (!bulkOperation) { return (<div />); }

        let opTokenText: string = '';
        let opFieldName: string = '';
        let opFieldValue: any;

        switch (bulkOperation) {
            default:
            case JobBulkUpdateOperations.SetJobsEnteredIntoQuickbooks:
                opTokenText = this.appText('modals.bulk-update-jobs.generic.entered-into-quickbooks');
                opFieldName = JobBulkUpdateFields.JobEnteredIntoQuickbooks;
                opFieldValue = true;
                break;

            case JobBulkUpdateOperations.SetJobsInvoiceSent:
                opTokenText = this.appText('modals.bulk-update-jobs.generic.invoice-sent');
                opFieldName = JobBulkUpdateFields.JobInvoiceSent;
                opFieldValue = true;
                break;
        }

        const modalButtonHandler = (e) => { this.handleConfirmBulkUpdateJobsButton(e, opFieldName, opFieldValue); };
        const modalTitle = this.appText('modals.bulk-update-jobs.generic.title', true, opTokenText);
        const modalNote = this.appText('modals.bulk-update-jobs.generic.note', true, opTokenText);
        const modalButtonText = this.appText('modals.bulk-update-jobs.generic.update-jobs', true, opTokenText);

        return (
            <Modal enforceFocus={false} show={this.state.showModalBulkUpdateJobs} onHide={() => this.handleCloseModalBulkUpdateJobs()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        {modalNote}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" onClick={(e) => modalButtonHandler(e)}>{modalButtonText}</Button>
                    <Button bsStyle="danger" onClick={() => this.handleCloseModalBulkUpdateJobs()}>{this.appTextCommon('buttons.cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    public renderHeaderButtonToolbar = (filterMode: any) => {
        let buttonProps = {
            bsSize: 'sm',
            bsStyle: 'info',
        };

        return (
            <div>
                <Well className="header-well-buttontoolbar">
                    <Row>
                        <Col xs={3}>
                            <ButtonToolbar>                                                                
                                <Button {...buttonProps} active={(filterMode === 1)} onClick={(e) => this.handleSelectReportMode(1)}><i className="fa fa-list-alt" /> {this.appText('filter-option-quickbooks')}</Button>
                                <Button {...buttonProps} active={(filterMode === 2)} onClick={(e) => this.handleSelectReportMode(2)}><i className="fa fa-envelope" /> {this.appText('filter-option-invoices')}</Button>
                            </ButtonToolbar>
                        </Col>                        
                    </Row>
                </Well>
            </div>
        );
    }

    public render() {
        const { search, ...rest } = this.props;

        const rows = this.extendGridData(search.results);

        const dataSource = GridUtilities.kendoGridDataSourcePaged(rows, {
            aggregate: [
                { field: 'acceptedPrice', aggregate: 'sum' }
            ],
            schema: {
                model: {
                    id: '_id',
                }
            }
        });

        const pageTitle = this.appTextResultsAndPageTitle(rows.length);
        let gridTitle = this.appTextResultsAndPageTitle(rows.length);

        const filterMode = _.get(search, 'filters.filterMode');
        
        switch (filterMode) {
            case 1:
            default: 
                gridTitle = this.appTextResultsAndPageTitle(rows.length, 'page-title.jobs', true, 'page-title.quickbooks', true);
                break;

            case 2:
                gridTitle = this.appTextResultsAndPageTitle(rows.length, 'page-title.jobs', true, 'page-title.invoices', true);
                break;
        }

        // Grid buttons
        let gridHeaderBulkActionButtonsDisabled = (_.size(_.get(this.state, 'selectedKeys', [])) > 0) ? false : true;

        let gridHeaderBulkActionButtons = (
            <div className="won-jobs-grid-toolbar-wrapper">
                <Row>
                    <Col xs={12}>
                        <ButtonToolbar className="association-inventory-components-grid-toolbar">
                            <DropdownButton
                                bsSize="xs"
                                disabled={gridHeaderBulkActionButtonsDisabled}
                                title={(<span><i className="fa fa-check-square-o" /> {this.appTextCommon('buttons.bulk-complete')}</span>)}
                                id="won-jobs-ddb-set-items-completion"
                                bsStyle="info"
                            >
                                <MenuItem
                                    eventKey="items-completed"
                                    onSelect={(k, e) => { this.handleShowModalBulkUpdateJobs(e, JobBulkUpdateOperations.SetJobsInvoiceSent); }}
                                >
                                    {this.appText('links.set-all-invoice-sent')}
                                </MenuItem>
                                <MenuItem
                                    eventKey="items-incomplete"
                                    onSelect={(k, e) => { this.handleShowModalBulkUpdateJobs(e, JobBulkUpdateOperations.SetJobsEnteredIntoQuickbooks); }}
                                >
                                    {this.appText('links.set-all-entered-into-quickbooks')}
                                </MenuItem>
                            </DropdownButton>
                        </ButtonToolbar>
                    </Col>
                </Row>
            </div>
        );

        const page = (
            <div>
                <div>
                    {this.renderBulkUpdateJobsModal()}
                    {this.renderHeaderButtonToolbar(filterMode)}
                </div>

                <WhiteBoxPageSection title={gridTitle}>
                    {gridHeaderBulkActionButtons}

                    <Row>
                        <Col xs={12}>
                            <Grid dataSource={dataSource} {...this.gridOptions} />
                        </Col>
                    </Row>
                </WhiteBoxPageSection>
            </div>
        );
        
        return (
            <AppComp.RenderPageWithLayout branding={this.props.branding} pageName={pageTitle} {...rest}>
                {page}
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getApiUrl = () => ApiEndpoints.getWonJobsSearchUrl();

const mapPropsToConfigs = (props) => ReduxQueries.Queries.searchWonJobsRequest(
    getApiUrl(),
    ReduxQueries.PropsAccessToken(props),
    _.get(props, 'search.filters.filterMode'),    
    _.get(props, 'search.filters.operator', '')
);

const mapStateToProps = (state, props) => {
    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(), state, props, {
        search: {
            results: state.entities.wonJobsResults,
            filters: {
                filterMode: state.searchFiltersWonJobs.filterMode,
                operator: 'AND',
            }
        },
    });
};

const mapDispatchToProps = dispatch => ({
    dispatch: (d) => dispatch(d),
    navigateTo: (path) => dispatch(push(path)),
    updateWonJobs: (d: any, a: string, o: boolean) => dispatch(MutateActions.updateWonJobsMutateAsync(d, a, o)),
});

const WonJobsContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
  )(WonJobs);

export default withRouter(WonJobsContainer);



// WEBPACK FOOTER //
// ./src/won-jobs/index.tsx